import {
  CARRIER_PICKUP_LOCATION_REQUESTING,
  LIST_CARRIER_PICKUP_LOCATION_SUCCESS,
  RESET_CARRIER_PICKUP_LOCATION_ISFETCHING,
  RESET_CARRIER_PICKUP_LOCATION_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CARRIER_PICKUP_LOCATION_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_CARRIER_PICKUP_LOCATION_QUERY: {
      return {
        ...state,
        query: null
      };
    }
    case CARRIER_PICKUP_LOCATION_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CARRIER_PICKUP_LOCATION_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
